module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOGVmYmNkYzk3NDQ1MDcwMGQ0MzkwNWVhNDJiNTY0MWYucG5nIjs="